import request from '@/plugins/axios'

/** S 商城列表 **/
// 商城列表
export const apiShopLists = (params: any) => request.get('/shop.shop/lists', {params})

// 添加商城
export const apiShopAdd = (params: any) => request.post('/shop.shop/add', params)

// 商城詳情
export const apiShopDetail = (params: any) => request.get('/shop.shop/detail', {params})

// 编辑商城
export const apiShopEdit = (params: any) => request.post('/shop.shop/edit', params)

// 获取商户支付配置列表
export const apiPayConfigLists = (params: any) => request.get('/settings.pay_config/getShopPayConfigs', {params})

// 更新支付配置启用状态
export const apiUpdatePayConfigEnable = (params: any) => request.post('/settings.pay_config/updatePayConfigEnable', params)

// 增加支付配置修改次数
export const apiIncreasePayConfigEditCount = (params: any) => request.post('/settings.pay_config/increaseEditCount', params)

// 删除商城
export const apiShopDelete = (params: any) => request.post('/shop.shop/delete', params)

// 修改超级管理员
export const apiShopChangeSuperAdmin = (params: any) => request.post('/shop.shop/changeSuperAdmin', params)

// 修改商城状态
export const apiShopSwitchStatus = (params: any) => request.post('/shop.shop/switchStatus', params)

// 历史套餐
export const apisetMealLogLists = (params: any) => request.get('/shop.shop/setMealLogLists', {params})

// 修改商城备注
export const apiChangeRemark = (params: any) => request.post('/shop.shop/changeRemark', params)

// 获取商户三方登录配置列表
export const apiOauthConfigLists = (params: any) => request.get('/settings.pay_config/getShopOauthConfigs', {params})

// 更新三方登录配置启用状态
export const apiUpdateOauthConfigEnable = (params: any) => request.post('/settings.oauth_config/updatePayConfigEnable', params)

// 增加三方登录配置修改次数
export const apiIncreaseOauthConfigEditCount = (params: any) => request.post('/settings.oauth_config/increaseEditCount', params)

/** E 商城列表 **/

/** S 套餐列表 **/
// 套餐列表
export const apiSetMealLists = (params: any) => request.get('/shop.set_meal/lists', {params})

// 添加套餐
export const apiSetMealAdd = (params: any) => request.post('/shop.set_meal/add', params)

// 套餐詳情
export const apiSetMealDetail = (params: any) => request.get('/shop.set_meal/detail', {params})

// 编辑套餐
export const apiSetMealEdit = (params: any) => request.post('/shop.set_meal/edit', params)

// 删除套餐
export const apiSetMealDelete = (params: any) => request.post('/shop.set_meal/del', params)

// 修改套餐状态
export const apiSetMealSwitchStatus = (params: any) => request.post('/shop.set_meal/status', params)

export const apiMealModule = () => request.get('/shop.set_meal/getMealModule')
/** E 套餐列表 **/

